import * as React from "react";
import { cn } from "./cn";

/**
 * Decorative dotted world-map motif — the Alight Creative brand mark. Rendered
 * as an inline SVG using `currentColor` so it inherits tone (e.g. wrap in a
 * `text-primary-fg/10` element). Purely ornamental, hidden from assistive tech.
 */
export function WorldMapMotif({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 1000 480"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
      className={cn("h-full w-full", className)}
      {...props}
    >
      {/* Stylised continents drawn as a dot grid. Decorative, not to scale. */}
      <pattern
        id="alight-worldmap-dots"
        x="0"
        y="0"
        width="14"
        height="14"
        patternUnits="userSpaceOnUse"
      >
        <circle cx="3" cy="3" r="2.4" />
      </pattern>
      {/* Continent silhouettes filled with the dot pattern. */}
      <g fill="url(#alight-worldmap-dots)">
        {/* Americas */}
        <path d="M170 70c40-10 90-6 110 18 18 22 6 52-10 78-8 36 14 70 6 108-6 30-40 48-58 78-16 26-50 30-66 6-12-26 8-58 2-86-8-40-44-66-48-106-4-44 28-86 62-96z" />
        {/* Europe + Africa */}
        <path d="M470 60c46-12 96 2 120 36 16 24 4 54 16 80 14 30 48 44 56 78 8 36-18 70-44 92-22 18-56 16-78 34-20 16-26 50-52 54-26 4-44-24-46-50-2-40 26-76 28-116 2-44-22-86-12-128 8-36 36-66 12-80-10-6-6-22-2-32 0-2 0-4 2-6z" />
        {/* Asia + Oceania */}
        <path d="M690 80c50-16 110-10 150 22 26 22 30 60 56 84 24 22 62 24 80 54 16 28 4 64-20 84-26 22-66 18-92 40-18 16-22 46-46 50-22 4-36-20-36-44 0-38 28-70 26-108-2-42-32-78-30-120 2-34 22-66-4-82-12-8-10-26-14-40z" />
        {/* small islands / dots */}
        <circle cx="840" cy="360" r="3" />
        <circle cx="870" cy="392" r="3" />
        <circle cx="300" cy="300" r="3" />
      </g>
    </svg>
  );
}
